const NA = 'NA';

const detectBrowser = (ua) => {
  if (/Edg\//i.test(ua)) return 'Edge';
  if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) return 'Chrome';
  if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return 'Safari';
  if (/Firefox\//i.test(ua)) return 'Firefox';
  if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return 'Opera';
  return 'Web Browser';
};

const detectOs = (ua) => {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
  if (/Android/i.test(ua)) return 'Android';
  if (/Mac OS X|Macintosh/i.test(ua)) return 'macOS';
  if (/Windows NT/i.test(ua)) return 'Windows';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Unknown OS';
};

/** Human-readable device label for attendance login/logout. */
export const getAttendanceDeviceLabel = () => {
  try {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
    if (!ua) return 'Web';
    return `${detectBrowser(ua)} on ${detectOs(ua)}`;
  } catch {
    return 'Web';
  }
};

const formatCoords = (latitude, longitude) => {
  if (latitude == null || longitude == null || Number.isNaN(latitude) || Number.isNaN(longitude)) {
    return NA;
  }
  return `${Number(latitude).toFixed(5)}, ${Number(longitude).toFixed(5)}`;
};

/**
 * Ask for browser geolocation. Returns NA fields when denied/unavailable.
 * Does not throw — callers can always attach the payload to confirm APIs.
 */
export const requestAttendanceLocation = () =>
  new Promise((resolve) => {
    const empty = {
      locationLabel: NA,
      latitude: null,
      longitude: null,
      locationAccuracyMeters: null,
    };

    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve(empty);
      return;
    }

    const timeoutId = setTimeout(() => resolve(empty), 8000);

    try {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          clearTimeout(timeoutId);
          const latitude = pos?.coords?.latitude;
          const longitude = pos?.coords?.longitude;
          const accuracy = pos?.coords?.accuracy;
          resolve({
            locationLabel: formatCoords(latitude, longitude),
            latitude: latitude != null ? String(latitude) : null,
            longitude: longitude != null ? String(longitude) : null,
            locationAccuracyMeters: accuracy != null ? Math.round(accuracy) : null,
          });
        },
        () => {
          clearTimeout(timeoutId);
          resolve(empty);
        },
        {
          enableHighAccuracy: false,
          timeout: 7000,
          maximumAge: 60_000,
        },
      );
    } catch {
      clearTimeout(timeoutId);
      resolve(empty);
    }
  });

/** Device + location payload for login/logout confirm requests. */
export const collectAttendanceClientContext = async () => {
  const location = await requestAttendanceLocation();
  return {
    deviceLabel: getAttendanceDeviceLabel(),
    locationLabel: location.locationLabel || NA,
    latitude: location.latitude,
    longitude: location.longitude,
    locationAccuracyMeters: location.locationAccuracyMeters,
  };
};
